/* eslint-disable */
// /src/pages/FranchiseApplyFormPage.jsx
// DH Mobility — 프랜차이즈 가입 신청 폼 화면
// - 개인/법인 별 구글 폼을 iframe 으로 표시
// - 상단에 뒤로가기 버튼 고정

import React from "react";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";
import Container from "../components/Container";

const Wrap = styled.div`
  min-height: 100vh;
  background: #f2f2f2;
  display: flex;
  flex-direction: column;
`;

const Body = styled.div`
  background: #fff;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05);
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
`;

const TopBar = styled.div`
  height: 52px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border-bottom: 1px solid #f2f2f2;

  button {
    border: 0;
    background: transparent;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    color: #111;
    font-weight: 700;
    padding: 6px 8px;
    border-radius: 10px;
  }

  button:active {
    transform: translateY(1px);
  }

  svg {
    width: 18px;
    height: 18px;
  }

  span {
    font-size: 14px;
    font-weight: 700;
  }
`;

const FrameWrap = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

const FormFrame = styled.iframe`
  flex: 1;
  width: 100%;
  border: 0;
`;

const BottomPad = styled.div`
  height: max(24px, env(safe-area-inset-bottom));
`;

export default function FranchiseApplyFormPage() {
    const navigate = useNavigate();
    const { type } = useParams();

    const personalUrl =
        "https://docs.google.com/forms/d/1mKd_-a141jSnW4Aj20DZS2C7shre-7YBDbAKLQ2ZDQM/viewform?ts=6736a509&edit_requested=true";
    const corporateUrl =
        "https://docs.google.com/forms/d/1eFBNuqo26Wjg-RDz7wxlr9Eig_8drvTLKY7uGilmp7o/viewform?ts=6736a4e2&edit_requested=true";

    const formUrl =
        type === "personal" ? personalUrl : type === "corporate" ? corporateUrl : null;

    if (!formUrl) {
        navigate("/franchise/apply", { replace: true });
        return null;
    }

    const title =
        type === "personal" ? "개인 가맹 가입 신청" : "법인 가맹 가입 신청";

    const handleBack = () => {
        navigate("/franchise/apply", { replace: true });
    };

    return (
        <Wrap>
            <Container noPadding full>
                <Body>
                    <TopBar>
                        <button onClick={handleBack} aria-label="가맹 가입 선택 화면으로 이동">
                            <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#111"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <polyline points="15 18 9 12 15 6" />
                            </svg>
                            <span>뒤로가기</span>
                        </button>
                   
                    </TopBar>

                    <FrameWrap>
                        <FormFrame src={formUrl} title={title} />
                        <BottomPad />
                    </FrameWrap>
                </Body>
            </Container>
        </Wrap>
    );
}
